// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/Dashboard.module.css */

/* General Layout */
.Dashbrd_dashboard__LcmzM {
    display: flex;
    height: 100vh;
    position: relative;
    overflow: hidden;
}

/* Sidebar */
.Dashbrd_sidebar__QG0vM {
    width: 60px; /* Collapsed width */
    background-color: #f5f5f5;
    padding: 20px 15px;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 50px;
    left: 0;
    cursor:pointer;
    height: 100vh;
    z-index: 1;
    transition: width 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.Dashbrd_sidebar__QG0vM.Dashbrd_expanded__us-WZ {
    width: 200px; /* Expanded width */
}

.Dashbrd_sidebarIcon__cfZRJ {
    font-size: 2rem;
    display: flex;
    justify-content: center;
}

.Dashbrd_sidebar__QG0vM .Dashbrd_MuiListItem-root__9oa0t {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 5px;
    transition: opacity 0.2s ease 0.1s; /* Slight delay for text appearance */
    opacity: 0; /* Initially hidden */
}

.Dashbrd_sidebar__QG0vM.Dashbrd_expanded__us-WZ .Dashbrd_MuiListItem-root__9oa0t {
    opacity: 1; /* Visible when sidebar is expanded */
}

.Dashbrd_sidebar__QG0vM .Dashbrd_MuiListItemIcon-root__Jxk2k {
    min-width: 40px; 
    color: #333;
}

/* Toggle Button */
.Dashbrd_toggleButton__f6p4v {
    position: absolute;
    top: 45%;
    right: -20px;
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transform: translateY(-50%);
}

/* Content Area */
.Dashbrd_content__hOKiu {
    flex-grow: 1;
    padding: 10px;
    padding-top: 80px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 15px;
    /* Remove margin-left to keep content stable */
}

/* Card */
.Dashbrd_card__tMW36 {
    min-width: 550px; /* Smaller card width */
    max-width: 350px;
    margin: 20px;
    padding: 30px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.Dashbrd_card__tMW36:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.Dashbrd_cardLogo__41OxH {
    width: 120px;
    height: 120px;
    display: block;
    margin: 0 auto;
    border-radius: 8px;
}

.Dashbrd_activeItem__rf1iG {
    background-color: #e0f7fa; /* Light blue background */
    /* color: #00796b; Dark teal text */
    font-weight: bold;
    border-radius: 4px;
  }
  
  .Dashbrd_activeItem__rf1iG .Dashbrd_MuiListItemIcon-root__Jxk2k {
    color: #333;
  }
  

/* Responsive Adjustments */

@media (max-width: 1600px) {
    .Dashbrd_card__tMW36 {
        min-width: 400px;
        max-width: 500px;
        padding: 15px;
        margin: 15px;
    }

    .Dashbrd_cardLogo__41OxH {
        width: 100px;
        height: 100px;
    }
    
    .Dashbrd_content__hOKiu {
        gap: 0 35px;
        margin-left: 135px;
    }
}



/* Adjustments for screens with 1366px width */
@media (max-width: 1366px) {
    .Dashbrd_card__tMW36 {
        min-width: 400px;
        max-width: 500px;
        padding: 15px;
        margin: 15px;
    }

    .Dashbrd_cardLogo__41OxH {
        width: 100px;
        height: 100px;
    }
    
    .Dashbrd_content__hOKiu {
        gap: 0 35px;
        margin-left: 100px;
    }
}

/* Further adjustments for 1280px width or smaller */
@media (max-width: 1280px) {
    .Dashbrd_sidebar__QG0vM.Dashbrd_expanded__us-WZ {
        width: 180px;
    }

    .Dashbrd_card__tMW36 {
        min-width: 400px;
        max-width: 500px;
        padding: 10px;
        margin: 5px;
    }

    .Dashbrd_cardLogo__41OxH {
        width: 100px;
        height: 100px;
    }

    .Dashbrd_content__hOKiu {
        gap: 0 35px;
        margin-left: 100px;
    }
}

/* Small screens or very small laptops */
@media (max-width: 992px) {
    .Dashbrd_sidebar__QG0vM {
        width: 45px;
    }

    .Dashbrd_sidebar__QG0vM.Dashbrd_expanded__us-WZ {
        width: 150px;
    }

    .Dashbrd_card__tMW36 {
        min-width: 240px;
        max-width: 260px;
        padding: 8px;
    }

    .Dashbrd_cardLogo__41OxH {
        width: 80px;
        height: 80px;
    }

    .Dashbrd_content__hOKiu {
        padding: 10px;
        gap: 5px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/component/dashboard/Dashbrd.module.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,mBAAmB;AACnB;IACI,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,WAAW,EAAE,oBAAoB;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,SAAS;IACT,OAAO;IACP,cAAc;IACd,aAAa;IACb,UAAU;IACV,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY,EAAE,mBAAmB;AACrC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,kCAAkC,EAAE,qCAAqC;IACzE,UAAU,EAAE,qBAAqB;AACrC;;AAEA;IACI,UAAU,EAAE,qCAAqC;AACrD;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,8CAA8C;AAClD;;AAEA,SAAS;AACT;IACI,gBAAgB,EAAE,uBAAuB;IACzC,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,qDAAqD;AACzD;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;IACrD,mCAAmC;IACnC,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;;AAGF,2BAA2B;;AAE3B;IACI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;;;AAIA,8CAA8C;AAC9C;IACI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA,oDAAoD;AACpD;IACI;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA,wCAAwC;AACxC;IACI;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,QAAQ;IACZ;AACJ","sourcesContent":["/* src/styles/Dashboard.module.css */\n\n/* General Layout */\n.dashboard {\n    display: flex;\n    height: 100vh;\n    position: relative;\n    overflow: hidden;\n}\n\n/* Sidebar */\n.sidebar {\n    width: 60px; /* Collapsed width */\n    background-color: #f5f5f5;\n    padding: 20px 15px;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);\n    position: fixed;\n    top: 50px;\n    left: 0;\n    cursor:pointer;\n    height: 100vh;\n    z-index: 1;\n    transition: width 0.3s ease;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.sidebar.expanded {\n    width: 200px; /* Expanded width */\n}\n\n.sidebarIcon {\n    font-size: 2rem;\n    display: flex;\n    justify-content: center;\n}\n\n.sidebar .MuiListItem-root {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding-left: 5px;\n    transition: opacity 0.2s ease 0.1s; /* Slight delay for text appearance */\n    opacity: 0; /* Initially hidden */\n}\n\n.sidebar.expanded .MuiListItem-root {\n    opacity: 1; /* Visible when sidebar is expanded */\n}\n\n.sidebar .MuiListItemIcon-root {\n    min-width: 40px; \n    color: #333;\n}\n\n/* Toggle Button */\n.toggleButton {\n    position: absolute;\n    top: 45%;\n    right: -20px;\n    background-color: #f5f5f5;\n    border: 1px solid #ccc;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transform: translateY(-50%);\n}\n\n/* Content Area */\n.content {\n    flex-grow: 1;\n    padding: 10px;\n    padding-top: 80px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    /* Remove margin-left to keep content stable */\n}\n\n/* Card */\n.card {\n    min-width: 550px; /* Smaller card width */\n    max-width: 350px;\n    margin: 20px;\n    padding: 30px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 20px;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.card:hover {\n    transform: scale(1.05);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n}\n\n.cardLogo {\n    width: 120px;\n    height: 120px;\n    display: block;\n    margin: 0 auto;\n    border-radius: 8px;\n}\n\n.activeItem {\n    background-color: #e0f7fa; /* Light blue background */\n    /* color: #00796b; Dark teal text */\n    font-weight: bold;\n    border-radius: 4px;\n  }\n  \n  .activeItem .MuiListItemIcon-root {\n    color: #333;\n  }\n  \n\n/* Responsive Adjustments */\n\n@media (max-width: 1600px) {\n    .card {\n        min-width: 400px;\n        max-width: 500px;\n        padding: 15px;\n        margin: 15px;\n    }\n\n    .cardLogo {\n        width: 100px;\n        height: 100px;\n    }\n    \n    .content {\n        gap: 0 35px;\n        margin-left: 135px;\n    }\n}\n\n\n\n/* Adjustments for screens with 1366px width */\n@media (max-width: 1366px) {\n    .card {\n        min-width: 400px;\n        max-width: 500px;\n        padding: 15px;\n        margin: 15px;\n    }\n\n    .cardLogo {\n        width: 100px;\n        height: 100px;\n    }\n    \n    .content {\n        gap: 0 35px;\n        margin-left: 100px;\n    }\n}\n\n/* Further adjustments for 1280px width or smaller */\n@media (max-width: 1280px) {\n    .sidebar.expanded {\n        width: 180px;\n    }\n\n    .card {\n        min-width: 400px;\n        max-width: 500px;\n        padding: 10px;\n        margin: 5px;\n    }\n\n    .cardLogo {\n        width: 100px;\n        height: 100px;\n    }\n\n    .content {\n        gap: 0 35px;\n        margin-left: 100px;\n    }\n}\n\n/* Small screens or very small laptops */\n@media (max-width: 992px) {\n    .sidebar {\n        width: 45px;\n    }\n\n    .sidebar.expanded {\n        width: 150px;\n    }\n\n    .card {\n        min-width: 240px;\n        max-width: 260px;\n        padding: 8px;\n    }\n\n    .cardLogo {\n        width: 80px;\n        height: 80px;\n    }\n\n    .content {\n        padding: 10px;\n        gap: 5px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `Dashbrd_dashboard__LcmzM`,
	"sidebar": `Dashbrd_sidebar__QG0vM`,
	"expanded": `Dashbrd_expanded__us-WZ`,
	"sidebarIcon": `Dashbrd_sidebarIcon__cfZRJ`,
	"MuiListItem-root": `Dashbrd_MuiListItem-root__9oa0t`,
	"MuiListItemIcon-root": `Dashbrd_MuiListItemIcon-root__Jxk2k`,
	"toggleButton": `Dashbrd_toggleButton__f6p4v`,
	"content": `Dashbrd_content__hOKiu`,
	"card": `Dashbrd_card__tMW36`,
	"cardLogo": `Dashbrd_cardLogo__41OxH`,
	"activeItem": `Dashbrd_activeItem__rf1iG`
};
export default ___CSS_LOADER_EXPORT___;
